export interface ClassSessionPayload {
    start_time: number;
    end_time: number;
}

export interface ClassSession extends ClassSessionPayload {
    timezone: string;
}

export interface ClassSessionWithGroupData extends ClassSession {
    label?: string;
    classSessionGroupUuid?: string;
    selectedGroups?: string[];
    attendanceType?: AttendanceType;
}

export enum AttendanceType {
    NoAttendance = 'track-attendance-none',
    Native = 'track-attendance-native',
    IntegrateWithLms = 'track-attendance-with-lms'
}

export interface CalendarValues {
    days: number[];
    timezone: string;
    dateRange: Date[];
    startTime: string;
    endTime: string;
    overnightAcknowledged?: boolean;
    label?: string;
    classSessionGroupUuid?: string;
    selectedGroups?: string[];
    attendanceType?: AttendanceType;
    startAndEndTime?: string;
}

export type CalendarValueKeys = (keyof CalendarValues);
